import styled from '@emotion/styled'

export const VerticalSpace = styled.div`
  margin: 2rem 0;
`
